import { useEffect, useRef } from 'react';
import { StyledMobileNav } from '@/components/styles';
import { ActiveLink, Footer } from '@/components';
import genLinkParams from '@/lib/generateLinkParams';

export default function MobileNav({ menu, isOpen = true, toggleMenuVisibility }) {
  const { text_pages: textPages } = menu;
  const sortedPages = sortTextPages(textPages);

  useEffect(() => {
    window.addEventListener('click', onClickOutside);
    return () => window.removeEventListener('click', onClickOutside);
  }, [isOpen]);

  const wrapper = useRef(null);

  const [servicesHref, servicesAs, servicesTitle] = genLinkParams({ type: 'services' });

  const onClickOutside = (e) => {
    if (isOpen && (!wrapper.current.contains(e.target) || wrapper.current === e.target)) {
      toggleMenuVisibility(e);
    }
  };

  return (
    <StyledMobileNav visible={isOpen} ref={wrapper}>
      <StyledMobileNav.Menu>
        <StyledMobileNav.MenuInner>
          <StyledMobileNav.Level visible={true}>
            <StyledMobileNav.LevelInner>
              <StyledMobileNav.Layout>
                <StyledMobileNav.List>
                  <StyledMobileNav.Item>
                    <ActiveLink href={servicesHref} as={servicesAs} addHrefActive={true} activeAs={'a'}>
                      <StyledMobileNav.Link onClick={toggleMenuVisibility}>{servicesTitle}</StyledMobileNav.Link>
                    </ActiveLink>
                  </StyledMobileNav.Item>

                  {Object.keys(sortedPages).length > 0 && (
                    <StyledMobileNav.Item>
                      <ActiveLink href={sortedPages.parent.href} as={sortedPages.parent.as}>
                        <StyledMobileNav.Link onClick={toggleMenuVisibility}>
                          {sortedPages.parent.title}
                        </StyledMobileNav.Link>
                      </ActiveLink>
                    </StyledMobileNav.Item>
                  )}

                  {['specialists', 'blog', 'contacts'].map((type, ind) => {
                    const [href, as, title] = genLinkParams({ type });
                    return <MobileNavItem key={ind} href={href} as={as} title={title} onClick={toggleMenuVisibility} />;
                  })}
                </StyledMobileNav.List>
              </StyledMobileNav.Layout>
            </StyledMobileNav.LevelInner>
          </StyledMobileNav.Level>
        </StyledMobileNav.MenuInner>
      </StyledMobileNav.Menu>
      <Footer isMap={false} isBottom={false} />
    </StyledMobileNav>
  );
}

function MobileNavItem({ href, as, title, children, ...props }) {
  return (
    <StyledMobileNav.Item>
      <ActiveLink href={href} as={as} addHrefActive={true} activeAs={'a'}>
        <StyledMobileNav.Link {...props}>{title}</StyledMobileNav.Link>
      </ActiveLink>

      {children}
    </StyledMobileNav.Item>
  );
}

function sortTextPages(pages) {
  let parent = null;
  let children = [];

  pages.forEach((page) => {
    const { is_main_for_menu: isMain, slug } = page;
    const [href, as] = genLinkParams({ type: 'text-page', slug });

    if (isMain) {
      parent = { ...page, href, as };
    } else {
      children.push({ ...page, href, as });
    }
  });

  return parent
    ? {
        parent,
        children,
      }
    : {};
}
